import { Component } from '@angular/core';
import { AuthPageLayoutComponent } from '../../../layout/auth-page-layout/auth-page-layout.component';
import { ResetPasswordForm } from '../../../components/auth/reset-password-form/reset-password-form';

@Component({
  selector: 'app-reset-password',
  imports: [
    AuthPageLayoutComponent,
    ResetPasswordForm,
  ],
  templateUrl: './reset-password.html'
})
export class ResetPassword {

}
